_ = require 'underscore'
CustomFieldBadgeView = require 'views/custom-field/custom-field-badge-view'
simpleTest = require 'lib/experiments/simple-test'
trackUe = require 'debug/trackUe'
View = require 'view'

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'

lastIdBoard = null
trackedFrontBadges = false

module.exports = class CustomFieldBadgesView extends View
  tagName: 'span'
  badgeView: CustomFieldBadgeView

  idForBadge: (customField, customFieldItem) ->
    idParts = [customField.id, customField.name, JSON.stringify(customField.options)]
    if customFieldItem
      idParts.push(customFieldItem.id)
      if customFieldItem.idValue
        idParts.push(customFieldItem.idValue)
      else
        idParts = idParts.concat([customFieldItem.color, JSON.stringify(customFieldItem.value)])

    idParts.join(':')

  render: ->
    board = @model.getBoard()
    if board.id != lastIdBoard
      lastIdBoard = board.id
      trackedFrontBadges = false

    subviews = board.customFieldList.map (customField) =>
      customFieldItem = @model.getCustomFieldItem(customField.id)
      #filter out those that aren't supposed to show on card front
      if !customFieldItem?.showFrontBadge()
        return null
      viewId = @idForBadge customField.toJSON(), customFieldItem.toJSON()
      @subview @badgeView, @model, { customFieldItem, customField }, viewId

    compacted = _.compact(subviews)
    @ensureSubviews compacted

    if compacted.length > 0
      @trackBadges()

    @

  trackBadges: ->
    if !trackedFrontBadges
      trackedFrontBadges = true
      trackUe('board view', 'views', 'Power-Up', '', '', 'card-badges', CUSTOM_FIELDS_ID)



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/custom-field-badges-view.coffee